import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { CircularProgress, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { BUSY_TYPES } from "../../../utils/busy.js";

import { CommonDialog } from "./common-dialog.jsx";

import "./style.less";

const getDialogTitle = (title, busyType, intl) => {
    if (title) {
        return title;
    }

    if (!busyType) {
        return null;
    }

    return intl.formatMessage({
        id: `common.progress-dialog.${busyType}.title`
    });
};

const ProgressDialog = ({
    title,
    progress,
    busyType,
    open,
    ...props
}) => {
    const intl = useIntl();
    const titleInner = getDialogTitle(title, busyType, intl);

    const [openInner, setOpenInner] = React.useState(false);

    useEffect(() => {
        const taskId = setTimeout(() => {
            if (open) {
                setOpenInner(true);
            }
        }
        , 100);

        return () => {
            clearTimeout(taskId);
            setOpenInner(false);
        }
    }
    , [open]);

    return(
        <CommonDialog className="progress-dialog" {...props} open={openInner}>
            <CircularProgress
                sx={{ color: "var(--font-4)" }}
                size="24px"
            />

            <Typography component="p" className="progress-dialog-title">{titleInner}</Typography>

            {
                progress &&
                <Typography component="p" className="progress-dialog-progress">{progress}</Typography>
            }
        </CommonDialog>
    )
}

ProgressDialog.propTypes = {
    title: PropTypes.node,
    progress: PropTypes.number,
    busyType: PropTypes.oneOf(Object.values(BUSY_TYPES)),
    open: PropTypes.bool,
};

export default ProgressDialog;
